module.exports = __webpack_public_path__ + "img/img24.197b1d56.jpg";